import { breakpoints } from 'config/config';
import styled from 'styled-components';

export const StyledListingsApplications = styled.div`
  @media only screen and (max-width: ${breakpoints.lg}px) {
    .mobile-list-card-cover-title {
      display: flex;
      flex-direction: column;
      width: 100%;

      span {
        font-size: 0.875rem;
      }

      .label {
        color: ${({ theme }) => theme.cardFirstElement};
      }
    }

    .mobile-list-card-body-wrapper .mobile-list-card-body-item {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid ${({ theme }) => theme.inputAddonBg};

      span {
        font-size: 0.875rem;
      }
    }

    .mobile-list-card-body-wrapper
      .mobile-list-card-body-item:nth-last-child(-n + 2) {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }

    .mobile-list-card-body-wrapper .ant-tag.status {
      display: inline-block;
      width: fit-content;
      margin-top: 2px;
    }

    .actions-title {
      text-align: start;
    }
  }

  .actions-title {
    text-align: center;
  }

  .status,
  .ant-tag.status {
    padding: 3px 10px;
    line-height: 18px;
    border-radius: 36px;
    font-size: 12px;
    color: ${({ theme }) => theme.white} !important;
    border: none;
    margin: 0;
  }

  .ant-tag.new,
  .new {
    background-color: ${({ theme }) => theme.statusUnpublished};
  }

  .ant-tag.submitted,
  .submitted {
    background-color: ${({ theme }) => theme.statusPublished};
  }

  .ant-tag.selected,
  .selected {
    background-color: ${({ theme }) => theme.statusHasOffers};
  }

  .ant-tag.accepted,
  .accepted {
    background-color: ${({ theme }) => theme.statusCompleted};
  }

  .ant-tag.rejected,
  .rejected {
    background-color: ${({ theme }) => theme.statusUnsuccessful};
  }

  .ant-tag.withdrawn,
  .withdrawn {
    background-color: ${({ theme }) => theme.statusCancelled};
  }

  .ant-select-selector {
    min-width: 150px;
  }

  .action {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .mobile-actions-button {
    width: 100%;
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};

    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
      opacity: 0.9;
    }
  }

  .link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-decoration: underline;
    font-weight: 500;
    transition: color 0.2s ease;
    white-space: nowrap;

    img {
      opacity: 0.7;
      transition: opacity 0.2s ease;
    }

    &:hover img {
      opacity: 1;
    }
  }

  .deadline-progress {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 150px;
    align-items: center;
  }

  .progress-bar {
    width: 100%;
    height: 3px;
    background-color: ${({ theme }) => theme.progressBar};
    border-radius: 3px;
    overflow: hidden;
    position: relative;
  }

  .progress-fill {
    height: 100%;
    background-color: ${({ theme }) => theme.progressBarFill};
    border-radius: 3px;
    transition: width 0.3s ease;
    position: relative;
    min-width: 2px;
  }
`;

export const StatusCell = styled.div`
  text-align: center;

  @media only screen and (max-width: ${breakpoints.lg}px) {
    text-align: end;

    .ant-tag {
      margin: 0;
      color: ${({ theme }) => theme.white} !important;
    }
  }
`;
